var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification"},[_c('CodeInput',{ref:"code-input",staticClass:"code-input",attrs:{"fields":_vm.num},on:{"change":_vm.onChange,"complete":_vm.submit}}),(_vm.timer)?_c('Timer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }